<template>
  <div id="dialogWrap">
    <el-dialog title="延期申请" :visible.sync="dialogVisible" width="730px">
      <div class="headStyle">
        <p class="cellPhone">登录账号：{{ tel }}</p>
        <img src="../../../assets/images/ykh.png" alt="">
        <p class="status">已开户</p>
      </div>
      <div class="noData">
        <p>请扫码延期申请</p>
        <vue-qr v-if="url" class="qrStyle" :text="url" style="display: block;" :margin="0"/>
        <p v-else class="noDataStyle">加载中</p>
        <p class="suptip">扫描上方二维码，进入移动端，进行延期申请</p>
      </div>
      <div class="dialog-footer">
        <el-button @click="goNext">取 消</el-button>
        <el-button type="primary" @click="goNext">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
/*global http protocol */

import VueQr from 'vue-qr'
export default {
  components: {
    VueQr
  },
  data() {
    return {
      tel: localStorage.getItem('myPhone'),
      baseUrl: window.g.APP_PATH_mobile,
      url: '',
      dialogVisible: false
    }
  },
  mounted() {

  },
  methods: {
    // 得到秘钥 --- 开户
    getSessionKey(type) {
      protocol.param_getSessionKeyOpen.url = `/base-desk-query/userSession/getSessionKey?type=${type}`
      http
        .getRes(protocol.param_getSessionKeyOpen)
        .then(response => {
          var { code, message, value } = response.data
          if (Number(code) === 0) {
            this.url = `${this.baseUrl}key=${value}&tel=${this.tel}`
          } else {
            this.$message(message)
          }
        })
        .catch(() => {
          // setTimeout(() => {
          //   this.queryQuantity()
          // }, 1000)
        })
    },
    goNext() {
      this.dialogVisible = false
    },
    showDialog() {
      this.dialogVisible = true
      this.getSessionKey(23)
    }
  }
}
</script>
<style lang="scss" scoped>
#dialogWrap {
  .noDataStyle{
    text-align: center;
    width: 100%;
    height: 200px;
    line-height: 200px;
    font-size: 24px;
    color: #333;
  }
  /deep/ .el-dialog__title{
      font-weight: 600;
      color: #000000 !important;
      font-size: 26px;
    }
  /deep/ .el-dialog {
    background: #F1F1F1!important;
    border-radius: 8px;
    .el-button {
      width: 112px;
      height: 46px;
      background: #D94066;
      border-radius: 23px;
      span{
        font-family: Source Han Sans SC;
        font-weight: 400;
        font-size: 18px;
        color: #FFFFFF;
      }
    }
    .el-button--primary{
      background-color: #0486FE;
      border: 1px solid #0486FE;
      span{
        color: #FFFFFF;
      }
    }
    .el-dialog__header {
      text-align: center;
      padding-top: 79px;
      padding-bottom: 15px;
      span{
        font-family: Source Han Sans SC;
        font-weight: bold;
        font-size: 24px;
        color: #333333;
      }
    }
    .el-dialog__body {
      padding: 0;
    }
    .el-dialog__footer {
      padding: 0 78px 40px 78px;
    }
    .headStyle {
      margin: 0 20px;
      padding-left: 70px;
      display: flex;
      align-items: center;
      height: 48px;
      border-top: 1px solid rgba(0, 0, 0, 0.1);
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      img {
        width: 16px;
        height: 20px;
        margin: 0 9px 0 20px;
      }
      .cellPhone {
        font-family: Source Han Sans SC;
        font-weight: 400;
        font-size: 20px;
        color: #333333;
      }
      .status {
        font-family: Source Han Sans SC;
        font-weight: 400;
        font-size: 14px;
        color: #3370FF;
      }
    }
  }
  .dataStyle .el-row {
    padding: 0 20px;
    padding-top: 10px;
    .el-col {
      display: flex;
      p {
        font-size: 16px;
        color: rgba(0, 0, 0, 0.6);
      }
      .text1 {
        font-weight: 500;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.8);
      }
      .line {
        width: 100%;
        height: 1px;
        background-color: rgba(0, 0, 0, 0.2);
        margin-bottom: 5px;
      }
    }
  }
  .bottomText {
    padding-top: 0px !important;
    padding-bottom: 20px !important;
  }
  .bottomLine {
    width: 100%;
    height: 1px;
    background-color: rgba(0, 0, 0, 0.2);
    margin-bottom: 30px;
  }
  .bottomBtn {
    text-align: center;
    padding-bottom: 30px;
    .el-button {
      width: 589px;
      height: 40px;
      padding: 0;
      font-size: 14px;
      span {
        color: #fff;
        font-size: 14px;
        font-weight: 500;
      }
    }
  }
  .noData {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
    margin-top: 25px;
    img {
      width: 270px;
      height: 270px;
      margin: 19px 0 23px;
    }
    p {
      font-family: Source Han Sans SC;
      font-weight: 400;
      font-size: 20px;
      color: #333333
    }
    .suptip{
      font-family: Source Han Sans SC;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
    }
  }
  .dialog-footer {
    text-align: center;
    padding: 80px 0 71px;
    .el-button {
      width: 112px;
      height: 46px;
      background-color: #D94066;
      border-radius: 23px;
      border: 0;
      span{
        font-family: Source Han Sans SC;
        font-weight: 400;
        font-size: 18px;
        color: #FFFFFF;
      }
    }
    .el-button--primary{
      background-color: #41B37D;
    }
    .el-button + .el-button {
      margin-left: 38px;
    }
  }
}
</style>
